import QrCodeIconLink from '../../../images/icons/qr-code.svg';

const QrCodeIcon = ({ ...properties }) => (
  <div
    data-testid="qr-code-icon-component"
    className="qrcode-icon-component"
    {...properties}
  >
    <img
      data-testid="qr-code-icon-image"
      src={QrCodeIconLink}
    />
  </div>
);

export default QrCodeIcon;
